export default __webpack_public_path__ + "static/media/redux.992f8f78.png";